// "Menu główne" from WordPress, shared by the header, the mobile drawer and
// the footer. The ids are the WordPress menu-item ids the theme's markup and
// stylesheet still reference (`menu-item-491`, …).

export default [
  { id: 491, label: 'Aukcje', to: '/aukcje/' },
  { id: 150, label: 'O nas', to: '/o-nas/' },
  { id: 492, label: 'Import', to: '/import/' },
  { id: 1267, label: 'Kalkulator', to: '/kalkulator/' },
]
